(() => {
  let pending = false;
  const path = (suffix) => `${window.Shopify?.routes?.root || '/'}${suffix}`;
  const json = async (response) => {
    const body = await response.json();
    if (!response.ok) throw new Error(body.description || body.message || 'Cart update failed');
    return body;
  };
  const refresh = async (drawer) => {
    const sections = await fetch(`${path('')}?sections=cart-drawer,cart-icon-bubble`).then(json);
    drawer.renderContents({ sections }, false);
  };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gj-add-express], [data-gj-save-size]');
    if (!button || pending) return;
    event.preventDefault();
    const drawer = button.closest('cart-drawer');
    if (!drawer) return;
    pending = true;
    button.disabled = true;
    const error = drawer.querySelector('[data-gj-cart-extra-error]') || drawer.querySelector('#CartDrawer-CartErrors');
    if (error) { error.hidden = true; error.textContent = ''; }
    const checkout = drawer.querySelector('[name="checkout"]');
    if (checkout) checkout.disabled = true;
    try {
      const cart = await fetch(path('cart.js')).then(json);
      if (button.matches('[data-gj-add-express]')) {
        const id = Number(button.dataset.variantId);
        if (!cart.items.some((item) => item.variant_id === id)) {
          await fetch(path('cart/add.js'), { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ items:[{ id, quantity:1 }] }) }).then(json);
        }
      } else {
        const editor = button.closest('[data-gj-size-editor]');
        const item = cart.items.find((line) => line.key === editor.dataset.lineKey);
        if (!item) throw new Error('This item has changed. Please reopen the cart.');
        const size = editor.querySelector('select').value;
        const properties = { ...item.properties, [editor.dataset.propertyName]:size };
        delete properties['Ring size override - confirm before crafting'];
        await fetch(path('cart/change.js'), { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ id:item.key, quantity:item.quantity, properties }) }).then(json);
      }
      await refresh(drawer);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source:'gj-cart-extras' });
    } catch (failure) {
      if (error) { error.textContent = failure.message; error.hidden = false; }
    } finally {
      pending = false;
      button.disabled = false;
      const currentCheckout = drawer.querySelector('[name="checkout"]');
      if (currentCheckout) currentCheckout.disabled = drawer.classList.contains('is-empty');
    }
  });
})();
